import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";

function ViewFeedbackById() {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    fetchFeedbackDetails();
  }, [id]);

  const fetchFeedbackDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://backend.placemyfilms.com/feedback/getFeedbackById/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseData = await response.json();

      if (responseData.status && responseData.result) {
        setFeedback(responseData.result);
      } else {
        setError(`Failed to fetch feedback details: ${responseData.message}`);
      }
    } catch (err) {
      setError(`Error fetching feedback details: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formatFieldName = (field) => {
    return field.replace(/([A-Z])/g, " $1").trim();
  };

  const formatValue = (field, value) => {
    if (field.toLowerCase().includes('at') && value) {
      return new Date(value).toLocaleString();
    }
    return value !== null && value !== "" ? value : "Not Available";
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box m="20px">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!feedback) {
    return (
      <Box m="20px">
        <Typography variant="h6">No feedback details found.</Typography>
      </Box>
    );
  }

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title="View Feedback Details" subtitle={`Feedback ID: ${id}`} />
      <Box ml={"40px"}>
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography
            variant="h6"
            fontWeight="bold"
            mb={2}
            color={colors.blueAccent[400]}
          >
            Feedback Details
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(feedback).map(([field, value]) => (
              <Grid item xs={12} key={field}>
                <Grid container>
                  <Grid item xs={3}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatFieldName(field)}:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>
                      {formatValue(field, value)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}

export default ViewFeedbackById;